export default __webpack_public_path__ + "67fc33d1276cafe1c4c16bddf4747ff1.svg";